var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { SkeletonRegistryStandardBlocks } from './categories/SkeletonRegistryStandardBlocks';
import { runtime } from '../../classes/runtime/Runtime';
import { registry } from '../Registry';
import { SkeletonRegistryQuestionTypes } from './categories/questiontypes/SkeletonRegistryQuestionTypes';
import { SkeletonRegistryLayout } from './categories/layout/SkeletonRegistryLayout';
import { RegistryRoof } from '../RegistryRoof';
import { editable, editObservable } from '../../utils/mobx/decorators/editable';
export class SkeletonRegistry extends RegistryRoof {
    registryType = 'skeleton';
    c_standardBlocks = new SkeletonRegistryStandardBlocks(this); // for hot reloading (see below)
    c_q = new SkeletonRegistryQuestionTypes(this);
    c_l = new SkeletonRegistryLayout(this);
    constructor(init) {
        super(init);
        editObservable(this);
    }
    get registry_object() {
        return super.registry_object;
    }
}
__decorate([
    editable('ref')
], SkeletonRegistry.prototype, "c_standardBlocks", void 0);
if (module.hot) {
    module.hot.accept('./categories/SkeletonRegistryStandardBlocks', () => {
        const SkeletonRegistryStandardBlocks = require('./categories/SkeletonRegistryStandardBlocks').SkeletonRegistryStandardBlocks;
        registry.skeletonRegistry.c_standardBlocks = new SkeletonRegistryStandardBlocks(this);
        if (runtime.isBrowserRuntime) {
            console.log('trigger Render in Module.hot');
            runtime.solidBrowserRuntime.browserRender.renderApp();
        }
    });
}
